export default __webpack_public_path__ + "static/media/deliveryDetails.e9445138.png";